
export type Severity = "HIGH" | "MEDIUM" | "LOW" | "NONE";

export const DEFAULT_PAGE_SIZE = 20;

export type IntervalType = "THIS_WEEK" | "LAST_WEEK" | "THIS_MONTH" | "LAST_MONTH" | "LAST_90_DAYS" | "ALL_TIME" | "CUSTOM";
